import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { useParams, useNavigate } from "react-router-dom";
import { usePatientInfo } from "../../hooks/usePatientInfo";
// import { ProfileContext } from "../../../context/ProfileProvider";

const ProfileCard = ({ patientInfo }) => {
  // const { data: patientData, isLoading: patientLoading, isError: isPatientError, error: patientError } = usePatientInfo(patientId);
  // console.log("patientData", patientInfo);
  // const { state, dispatch } = useContext(ProfileContext);
  const [patientDetail, setPatientDetail] = useState({
    name: "Mahir Labib Dihan",
    patient_id: "1905072",
    age: "25",
    phone: "01851953433",
    gender: "Male",
  });
  const [plotResult, setPlotResult] = useState(null);

  const [topNotes, setTopNotes] = useState([]);
  const [profile, setProfile] = useState(null);

  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const apiEndpoint =
    "https://vaz40kx3ck.execute-api.us-east-1.amazonaws.com/v1/db_query";
  const headers = {
    "Content-Type": "application/json",
  };

  const navigate = useNavigate();
  // const { patientId } = useParams();

  // useEffect(() => {
  // 	const profiles = state?.profile;
  // 	if (profiles?.success) {
  // 		setProfile(profiles?.data);
  // 	}

  // 	console.log("profile");
  // 	const get_req_value2 = {
  // 		clinicianId: profiles?.data?.user_id,
  // 		patientId: patientId,
  // 		task: "specificPatientData",
  // 	};
  // 	const queryParams2 = new URLSearchParams(get_req_value2).toString();
  // 	const apiUrl2 = `${apiEndpoint}?${queryParams2}`;

  // 	fetch(apiUrl2, {
  // 		method: "GET",
  // 		headers: headers,
  // 	})
  // 		.then((response) => response.json())
  // 		.then((data) => {
  // 			if (
  // 				data.clinical_response_result &&
  // 				data.clinical_response_result.length > 0
  // 			) {
  // 				const firstFiveNotes = data.clinical_response_result.slice(
  // 					0,
  // 					5
  // 				);
  // 				setTopNotes(firstFiveNotes);
  // 			}
  // 			setPatientDetail(data.details_query_result[0]);
  // 		})
  // 		.catch((error) => {
  // 			console.error("Error:", error);
  // 		});

  // 	const get_req_value = {
  // 		patientId: patientId,
  // 		task: "patientSubmitFormData",
  // 	};

  // 	const queryParams = new URLSearchParams(get_req_value);

  // 	const apiUrl = `${apiEndpoint}?${queryParams}`;
  // 	fetch(apiUrl, {
  // 		method: "GET",
  // 		headers: headers,
  // 	})
  // 		.then((response) => {
  // 			return response.json();
  // 		})
  // 		.then((data) => {
  // 			const parsedData = JSON.parse(
  // 				data.plot_query_result
  // 					.replace(/None/g, "null")
  // 					.replace(/'/g, '"')
  // 			);
  // 			setPlotResult(parsedData);
  // 		})
  // 		.catch((error) => {
  // 			console.error("Error:", error);
  // 		});
  // }, [state?.profile]);

  return (
    <>
      <div className="bg-white rounded-3 p-4 cardPaitent !h-full">
        <div className="d-flex align-items-center">
          <div className="flex-shrink-0">
            {patientDetail.imageSrc ? (
              <img className="w-100" src="images/profileSide.png" alt="" />
            ) : (
              <div
                className="rounded-circle text-white d-flex justify-content-center align-items-center"
                style={{
                  width: "50px",
                  height: "50px",
                  fontSize: "24px",
                  backgroundColor: "#3F4A9C",
                }}
              >
                {patientDetail.name[0]}
              </div>
            )}
          </div>

          <div className="flex-grow-1 ms-4">
            <div className="d-flex justify-content-between">
              <h4>{patientInfo.name}</h4>
            </div>
            <div className="row">
              {/* <div className="col-12">
                <label>
                  Patient No : <span>{patientDetail.patient_id}</span>
                </label>
              </div> */}
              <div className="col-12">
                <label>
                  Age : <span>{patientInfo.age} years</span>
                </label>
              </div>
              <div className="col-12">
                <label>
                  Gender : <span>{patientInfo.gender}</span>
                </label>
              </div>
              <div className="col-12">
                <label>
                  Phone : <span>{patientInfo.phone}</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* {["psychiatrist", "primaryTherapist", "groupTherapist"].map(
          (role, index) => (
            <div className="col-md-12 mt-3" key={index}>
              <div className="d-flex align-items-center">
                <label className="me-2">
                  {" "}
                  {role.charAt(0).toUpperCase() + role.slice(1)}:{" "}
                </label>
                <h6 className="mb-0">
                  <img src="images/doctor-pic.png" alt="" />{" "}
                  {patientDetail[`${role}`]}
                </h6>
                <span className="ms-2 date">
                  {" "}
                  | {patientDetail[`${role}Date`]}
                </span>
              </div>
              <p className="mb-0">{patientDetail[`${role}Note`]}</p>
            </div>
          )
        )}

        <div className="col-md-12 mt-3">
          <div className="d-flex align-items-center">
            <label className="me-2">ICD-10 codes : </label>
            <p className="mb-0">{patientDetail.icdCodes}</p>
          </div>
        </div>

        <div className="col-md-12 mt-2">
          <div className="d-flex align-items-center">
            <label className="me-2">Clinical Tasks : </label>
          </div>
          <p className="mb-0">
            <span className="text-success">@Walter Pearlman</span> do PTSD
            assessment <br />
            <span className="text-success">@Walter Pearlman</span> create
            treatment plan
          </p>
        </div> */}

        {/* <div className="col-md-12 mt-3">
						<div className="d-flex align-items-center mb-2">
							<label className="me-2">Previous review: </label>
							<span className="ms-2 date"> Nov 6 2023</span>
						</div>
						<div className="d-flex align-items-center">
							<label className="me-2">Upcoming review: </label>
							<span className="ms-2 date">Nov 16 2024</span>
						</div>
					</div> */}

        {/* <div className="col-md-12 mt-3">
						<div className="d-flex align-items-center">
							<label className="me-2">Insurance feedback :</label>
							<p className="mb-0">
								Wants to avoid HLOC and approved IOP not PHP,
								and agrees with current treatment plan.
							</p>
						</div>
					</div>
					<div className="col-md-12 mt-3">
						<div className="d-flex align-items-center">
							<label className="me-2">Claim status: </label>
							<span className="ms-2 date">
								<i className="fas fa-check-circle text-success"></i>{" "}
								5 day IOP
							</span>
						</div>
					</div>
					<div className="col-md-12 mt-3">
						<div className="d-flex align-items-center">
							<label className="me-2">
								Financial communication:
							</label>
						</div>
						<p className="mb-0">patient has outstanding bill </p>
					</div> */}
        {/* <div className="col-md-12 mt-3">
						<hr />
					</div>
					<div className="col-md-12 mt-2">
						<div className="d-flex align-items-center">
							<label className="me-2">Intake date :</label>
							<p className="mb-0">July 24 2023</p>
						</div>
					</div>
					<div className="col-md-12 mt-2">
						<div className="d-flex align-items-center">
							<label className="me-2">Insurance firm :</label>
							<p className="mb-0">Aetna PPO</p>
						</div>
					</div>
					<div className="col-md-12 mt-2">
						<div className="d-flex align-items-center">
							<label className="me-2">Dischaerge :</label>
							<p className="mb-0">jan 24 2024</p>
						</div>
					</div>
					<div className="col-md-12 mt-2">
						<div className="d-flex align-items-center">
							<label className="me-2">Level of care :</label>
							<p className="mb-0">VIOP</p>
						</div>
					</div>
					<div className="col-md-12 mt-2">
						<div className="d-flex align-items-center dischargeTxt">
							<i className="fas fa-minus-circle me-1"></i>
							<label className="me-2 dischargeTxt">
								<Link
									to={`/profile/newPatient/${patientId}/page1`}
									className="text-decoration-none"
								>
									Profile
								</Link>
							</label>
						</div>

						<div className="d-flex align-items-center dischargeTxt">
							<i className="fas fa-minus-circle me-1"></i>
							<label className="me-2 dischargeTxt">
								<Link
									to={`/profile/discharge/${patientId}/page1`}
									className="text-decoration-none"
								>
									Discharge patient
								</Link>
							</label>
						</div>
					</div> */}
      </div>
    </>
  );
};

export default ProfileCard;
